import React from 'react';
import Modal from "../component/modal";  // 假设你的 Modal 组件在这个路径下

class RegionModal extends React.Component {
    render() {
        const { allProvinceList, tempSelectedRegions, handleRegionToggle, closeRegionOptions, confirmRegionSelection } = this.props;

        return (
            <Modal origin='xkCoachBottom' onCancel={closeRegionOptions}>
                <div className='show-region-modal'>
                    <div className="modal-title">
                        筛选院校地区
                        <svg t="1676039031388" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10861" width="16" height="16" onClick={closeRegionOptions}>
                            <path
                                d="M511.232 438.8352L112.9984 40.6016A51.2 51.2 0 0 0 40.6016 112.9984L438.784 511.232 40.6016 909.4656a51.2 51.2 0 1 0 72.3968 72.448l398.2336-398.2848 398.2336 398.2848a51.2 51.2 0 1 0 72.448-72.448l-398.2848-398.2336 398.2848-398.2336A51.2 51.2 0 0 0 909.4656 40.601">
                            </path>
                        </svg>
                    </div>
                    <div className="modal-center">
                        <div className="options-container">
                            {allProvinceList.map(option => (
                                <label key={option.id}>
                                    <input 
                                        type="checkbox" 
                                        checked={tempSelectedRegions.includes(option.id)} 
                                        onChange={() => handleRegionToggle(option.id)} 
                                    />
                                    {option.name}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="modal-bottom">
                        <div className="btn cancel" onClick={closeRegionOptions}>关闭</div>
                        <div className="btn confirm" onClick={confirmRegionSelection}>确定</div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default RegionModal;



// WEBPACK FOOTER //
// ./src/pages/SelectSubject/RegionModal.js